import React from "react";
import { Spinner } from "react-bootstrap";


export function SubHeaderLoading() {
  return (
    <div className="w-100 d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
      <Spinner animation="border" variant="primary" />
    </div>
  );
}

export function ContentWithCardLoading() {
  return (
    <div className={`card card-custom`}>
      <div className="card-body py-3 px-3" style={{ padding: 15 }}>
        <div className="w-100 d-flex justify-content-center align-items-center" style={{ minHeight: "calc(100vh - 200px)" }}>
          <Spinner animation="border" variant="primary" />
        </div>
      </div>
    </div>
  );
}

export const ContentLoadingWithoutCard = () => (
  <div className="w-100 d-flex justify-content-center align-items-center" style={{ minHeight: "calc(100vh - 200px)" }}>
    <Spinner animation="border" variant="primary" />
  </div>
);

export function ContentWithCardLoadingForSettings() {
  return (
    <div className={`card card-custom`}>
      <div className="card-body py-3 px-3" style={{ padding: 15 }}>
        <div className="w-100 d-flex justify-content-center align-items-center" style={{ minHeight: "calc(100vh - 300px)" }}>
          <Spinner animation="border" variant="primary" />
        </div>
      </div>
    </div>
  );
}
